import React from "react";
import logo_top from "../../../assets/images/logo_top.png"

function University_logo() {
    return (
        <div>
            <div className="background_area">
                <div className="img_area">
                    <img src={logo_top} alt="" />
                </div>
            </div>
        </div>
    );
}

export default University_logo;
